import * as Yup from 'yup';

import { configurationSchema } from '../configuration/configuration';

export type Configuration = Yup.InferType<typeof configurationSchema>;
export type AngleConfiguration = NonNullable<Configuration['angles']>[number];
export type PressureConfiguration = NonNullable<
  Configuration['pressures']
>[number];
export type FlowRateConfiguration = NonNullable<
  Configuration['flowRates']
>[number];
export type MonitorConfiguration = NonNullable<
  Configuration['monitors']
>[number];
export type MonitorCompatibleNozzleConfiguration = NonNullable<
  MonitorConfiguration['compatibleNozzles']
>[number];
export type NozzleConfiguration = NonNullable<Configuration['nozzles']>[number];
export type WorkingAreaConfiguration = NonNullable<
  MonitorConfiguration['workingArea']
>[number];
export type ImageWithPivot = MonitorConfiguration['image'];

export type MediaType = 'foam' | 'water';

export type Point = { x: number; y: number };

export type Curve = Array<Point>;

export type LineSegment = { start: Point; end: Point };

export type Obstacle = {
  left: number;
  right: number;
  top: number | null;
  bottom: number;
};

export type TrajectoryGroup = {
  mainTrajectory: Curve;
  minFootprintTrajectory: Curve;
  maxFootprintTrajectory: Curve;
};

export type ObstacleInput = {
  distance: number;
  height: number;
  depth: number;
};

export type MergedTrajectory = {
  x: number;
  y: number;
  minFootprintX: number;
  minFootprintY: number;
  maxFootprintX: number;
  maxFootprintY: number;
};

export enum Units {
  Metric = 'metric',
  Imperial = 'imperial',
}

export enum UnitTypes {
  Meter = 'meter',
  Liter = 'liter',
  Newton = 'newton',
  Bar = 'bar',
}
